var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndurance24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12Z",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.285 10.713C13.6753 10.3232 14.0858 9.91329 14.5774 9.42234C15.2261 8.78969 16.1128 8.3999 17.0906 8.3999C19.0788 8.3999 20.6906 10.0117 20.6906 11.9999C20.6906 13.9881 19.0788 15.5999 17.0906 15.5999C16.0253 15.5999 15.0681 15.1372 14.4089 14.4018L12.0033 11.9929L9.42277 9.42234C8.77402 8.78969 7.88731 8.3999 6.90957 8.3999C4.92135 8.3999 3.30957 10.0117 3.30957 11.9999C3.30957 13.9881 4.92135 15.5999 6.90957 15.5999C7.97486 15.5999 8.93207 15.1372 9.5912 14.4018L10.7067 13.2878",
    stroke: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndurance24X24);
export default __webpack_public_path__ + "static/media/Endurance-24x24.2162f0d7be36cb1405590b4843a4f64a.svg";
export { ForwardRef as ReactComponent };